package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import component.*
import input.*
import scenes.*

class DashControlSystem(
    private val controllerData: InputControllerData = inject(),
    private val inputController: InputController = inject(),
) : IteratingSystem(family { all(PlayerComponent) }) {

    private val DASH_COOLDOWN = 5f
    private var cooldownAccumulator = 0f

    val DASH_VELOCITY = 15f

    private var velocityBuffer = 0f
    private var applyingVelocity = 0f

    private val dashTime = 1f / 60f * 10
    private var dashTimeAccumulator = 0f

    override fun onTickEntity(entity: Entity) {
        val playerComp = entity[PlayerComponent]
        val physicComponent = entity[PhysicComponent]
        if (playerComp.isDashActive) {
            controllerData.dashButton?.disable()
            if (dashTimeAccumulator >= dashTime) {
                playerComp.isDashActive = false
                dashTimeAccumulator = 0f
                physicComponent.body.linearVelocityX = velocityBuffer
                physicComponent.body.linearVelocityY = 0f

                return
            }
            controllerData.dashButton?.setActive()
            physicComponent.body.linearVelocityX = applyingVelocity
            dashTimeAccumulator += deltaTime
        }

        if (cooldownAccumulator < DASH_COOLDOWN) {
            controllerData.dashButton?.disable()

            cooldownAccumulator += deltaTime
            return
        } else {
            playerComp.isDashActive = false
            controllerData.dashButton?.enable()
        }

        if (inputController.dash.current) {
            cooldownAccumulator = 0f
            playerComp.isDashActive = true
            applyingVelocity = if (playerComp.direction == BodyDirection.RIGHT) {
                DASH_VELOCITY
            } else {
                -DASH_VELOCITY
            }
            velocityBuffer = physicComponent.body.linearVelocityX

            controllerData.dashButton?.enable()
            controllerData.dashButton?.setActive()
        }
    }
}
